import Space from "@modules/navigator/Space/Space.js";
import App from "@templates/App/App.js";
import ShopsBubble from "@modules/navigator/Shops/ShopsBubble/ShopsBubble.js";
import Popup from "@templates/Components/Popup/Popup.js";

const Shops = {
    data: null,

    init() {
        this.el = $('[page="obchody"]');
        if (!this.el.length) return;

        this.spaces = NAVIGATOR_DATA.flats;

        this.floorPlans = this.el.find("svg");
        this.flats = this.floorPlans.find('#areas path[id], #areas_2 path[id], #areas rect[id], #areas_2 rect[id]');
        this.popup = $('[component="Popup"][name="shops"]');

        ShopsBubble.init();

        this.prepare();
        this.bind();
    },

    prepare() {
        $.each(this.flats, (index, flat) => {
            const letter = $(flat).attr("id");
            const id = '1' + letter;
            const data = this.spaces[id];

            $(flat).attr("popup", "shops");

            if (!!!data) {
                $(flat).addClass("NAN");
                return;
            }

            if (Space.isAvailable(data)) {
                $(flat).addClass("available");
            }

            if (Space.isSold(data)) {
                $(flat).addClass("sold");
            } else if (Space.isReserved(data)) {
                $(flat).addClass("reserved");
            }

            if (Space.isInDev(data)) {
                $(flat).addClass("dev");
            }
        });
    },

    bind() {
        // // --- DESKTOP only ---
        if (App.isDesktop || App.isLandscape) {
            this.flats.mouseover((evt) => {
                this.onEnter(evt)
            });

            this.flats.mouseleave((evt) => {
                console.log(evt)
                this.onLeave(evt)
            });

            this.flats.click((evt) => {
                this.onClick(evt)
            });
        }

        // --- MOBILE and TABLET ---
        if (!App.isDesktop || App.isPortrait) {
            this.flats.click((evt) => {
                this.onEnter(evt)
            });
        }
    },

    onClick(evt) {
        const id = "1" + $(evt.currentTarget).attr("id");
        this.data = this.spaces[id];

        ShopsBubble.hide();

        this.preparePopup();

        if (App.isDesktop || App.isLandscape) {
            Popup.open($(evt.currentTarget).attr('popup'), $(evt.currentTarget).attr('popup-color'));
        }
    },

    onEnter(evt) {
        const flat = $(evt.currentTarget);
        const id = "1" + flat.attr("id");

        ShopsBubble.show(evt, flat, this.spaces[id]);
    },

    onLeave() {
        ShopsBubble.hide();
    },

    preparePopup() {
        this.popup.find("header .type").html(this.data.type);
        this.popup.find("header .name").html(this.data.name);
        this.popup.find("header .meter .value").html(this.data.living_space);
        this.popup.find(".spacePlan img").attr("src", this.data.plan_image);
        this.popup.find('input[name="flat_name"]').val(this.data.name);
        this.popup.find('input[name="flat_id"]').val(this.data.id);
    }
}

export default Shops;